import React from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className='footer'>
      {/* Scrolling Marquee for Service Areas */}
      <div className='marquee-wrapper'>
        <div className='marquee'>
          <span>
            Proudly Serving: Mamaroneck | Larchmont | New Rochelle | Rye | Harrison | White Plains | Scarsdale | Port Chester | Pelham | Eastchester | Yonkers | Mount Vernon &nbsp;&nbsp;&nbsp;
          </span>
          <span>
            Proudly Serving: Mamaroneck | Larchmont | New Rochelle | Rye | Harrison | White Plains | Scarsdale | Port Chester | Pelham | Eastchester | Yonkers | Mount Vernon &nbsp;&nbsp;&nbsp;
          </span>
        </div>
      </div>

      {/* <div className='footer-marquee'>
        <marquee behavior='scroll' direction='left'>
          Proudly Serving: Mamaroneck  |  Larchmont | New Rochelle | Rye | Harrison | White Plains | Scarsdale | Port Chester | Pelham | Eastchester | Yonkers | Mount Vernon
        </marquee>
      </div> */}
      
      {/* Footer Main Content */}
      <div className='footer-container'>
        {/* <div className='footer-links'>
          <NavLink to='/about'>About</NavLink>
          <NavLink to='/services'>Services</NavLink>
          <NavLink to='/contact'>Contact</NavLink>
        </div> */}
        
        <div className='footer-contact'>
          <p>Email: info@westchestermusiclab.com</p>
        </div>
        <div className='footer-bottom'>
          <p>© {new Date().getFullYear()} Westchester Music Lab. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;